import React, { useEffect } from "react";
import { motion } from "framer-motion";
// import { theme } from 'styled-tools';
import { HeadingTextWrapper } from "../../common/Headings";
// import CasinoSlider from './casino-slider';
// import RecommendedGames from './recommended-games';
import CasinoTabGames from "./casino-tab-games";
// import { color } from "../../../sass-files/variable";
// import casinoBg from '../../../images/iexch_casino_bgone.jpg';
// import Intl from "../../common/Intl";
import styled, { withTheme } from "styled-components";
import { withAppContext } from "src/store/initAppContext";
import config from "src/config/config";
import { Link, useParams } from "react-router-dom";
// import SEOContents from "src/components/SEOContents";

import { CRMPageVisit } from "src/util/crmUtil";

import { getDamain } from "src/util/commonfun";
// import CasinoSlider from "./casino-slider";
// import Slider from "react-slick";
// const {titleHeadColor} = color
// const andarBahar = `${'/static/media/andarBaharslide.jpg'}`
// const AviatorSlide = `${'/static/media/AviatorSlide.jpg'}`
// const CrazyTimeSlide = `${'/static/media/CrazyTimeSlide.jpg'}`
// const DreamCatcherSlide = `${'/static/media/DreamCatcherSlide.jpg'}`
// const goalSlide = `${'/static/media/goalSlide.jpg'}`
// const Hiloslide = `${'/static/media/Hiloslide.jpg'}`
// const LightningRouletteSlide = `${'/static/media/LightningRouletteSlide.jpg'}`
// const TeenpattiSlide = `${'/static/media/TeenpattiSlide.jpg'}`
// const MonopolySlide = `${'/static/media/MonopolySlide.jpg'}`
// const VegasMagic=`${'/static/media/VegasMagicSlide.jpg'}`


// const imageGroup: any = {
//   web: [
//     {
//       img: 'slider_1', name: 'slider_image_1', id: 1, src:AviatorSlide, alt_name: 'aviator', pathName: '/live-casino/aviator'
//     },
//     {
//       img: 'slider_2', name: 'slider_image_2', id: 2, src: andarBahar, alt_name: 'Banner_image_11', pathName: '/live-casino/andar bahar'
//     },
//     {
//       img: 'slider_6', name: 'slider_image_6', id: 6, src:  CrazyTimeSlide, alt_name: 'smartsoft', pathName: '/live-casino/EVOLUTIONBLACKJACK'
//     },
//     {
//       img: 'slider_2', name: 'slider_image_2', id: 2, src:DreamCatcherSlide, alt_name: 'lodo', pathName:'/live-casino/EVOLUTIONBLACKJACK'
//     }, 
//     {
//       img: 'slider_3', name: 'slider_image_3', id: 3, src:  goalSlide, alt_name: 'Banner_image_1', pathName: '/live-casino/goal'
//     },
//     {
//       img: 'slider_3', name: 'slider_image_3', id: 3, src:  Hiloslide, alt_name: 'Banner_image_1', pathName: '/live-casino/hilo'
//     },
//     {
//       img: 'slider_3', name: 'slider_image_3', id: 3, src:  LightningRouletteSlide, alt_name: 'Banner_image_1', pathName: '/live-casino/Lightning'
//     },
//     {
//       img: 'slider_3', name: 'slider_image_3', id: 3, src:  TeenpattiSlide, alt_name: 'Banner_image_1', pathName: '/live-casino/teenpatti'
//     },
//     {
//       img: 'slider_3', name: 'slider_image_3', id: 3, src:  MonopolySlide, alt_name: 'Banner_image_1', pathName: '/live-casino'
//     },
//     {
//       img: 'slider_3', name: 'slider_image_3', id: 3, src:  VegasMagic, alt_name: 'Banner_image_1', pathName: '/live-casino/populargames/vegas'
//     }


//   ]
// }

// const sliderSettings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   arrows: false,
//   pauseOnHover:true
// };




function CasinoPage(props) {
  const { id: gameName, provider: providerName } = useParams();
  const { app: { brandId } } = props;

  let domainURL = getDamain(brandId);

  useEffect(() => {
    //for CRM
    CRMPageVisit();
  }, []);

  const _structuredDataid = providerName && gameName ? gameName : providerName;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <CasinoWrapper theme={props.app.theme} customStyle={props.theme.image}>
        {/* <TitleHead theme={props.app.theme} customStyle={props.theme.palette}>
          <Intl langKey="TITLE@CASINO" />
        </TitleHead> */}
        {/* <RecommendedGames/> */}
        {/* <CasinoSlider/> */}
        <CasinoTabGames />
      </CasinoWrapper>
    </motion.div>
  );
}

export default withTheme(withAppContext(CasinoPage));

const CasinoWrapper: any = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-image: url("${(props: any) => `${config.imageV3Host}/static/cashsite/${props.customStyle["homeExchangeBgImage"]}`}");
  background-position: 100%;
  background-size: cover;
`;

const TitleHead = styled(HeadingTextWrapper)`
  font-size: 28px;
  letter-spacing: 3px;
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: bold;
  color: ${(props: any) => (props.theme === "Dark" ? "#FFF" : "#F4A322")};
  margin-left: 1em;
  padding-top: 10px;
  position: relative;
  margin-bottom: 10px;
  padding-bottom: 5px;

  :after {
    content: "";
    width: 500px;
    height: 2px;
    background: linear-gradient(90deg, #f7b349 0%, rgba(235, 160, 42, 0) 50%);
    position: absolute;
    bottom: 0;
    left: 0;
  }

  @media only screen and (max-width: 992px) {
    font-size: 30px;
  }
`;

const SliderWrap = styled.div`
  /* min-height: 300x; */
  height: auto;

.slick-dots {
    display: flex!important;
    align-items: center;
    justify-content: center;
    padding: 10px;
    bottom: 4px;
    background-color: transparent;

    li {
        margin: 0px 1px;
    }
    li button:before {
        font-size: 13px;
        color: #c78e35;
    }
    li.slick-active button:before {
        opacity: .75;
        color: #da911f;
    }
}
`
